import { render, staticRenderFns } from "./RedeemNow_jdyx.vue?vue&type=template&id=122f4759&scoped=true"
import script from "./RedeemNow_jdyx.vue?vue&type=script&lang=js"
export * from "./RedeemNow_jdyx.vue?vue&type=script&lang=js"
import style0 from "./RedeemNow_jdyx.vue?vue&type=style&index=0&id=122f4759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f4759",
  null
  
)

export default component.exports